<template lang="pug">
    ib-modal(
        ref="modal",
        :width="width",
        :height="height",
        role="alertdialog",
        describedby="_confirm-msg")
        article(id="_confirm-msg", dir="auto", v-markdown._blank="msg")
        template(slot="buttons")
            div(v-if="dismissable", class="_mdismiss")
                ib-checkbox(v-model="dismiss", class="fs7") {{$locale.data.dismissable}}
            ib-button-group
                ib-button(@click="onCancel", bind="Escape") {{verbCancel || $locale.data.Cancel}}
                ib-button(:tone="tone", @click="onAccept", autofocus) {{verb || $locale.data.Accept}}
</template>

<script>
    /**
     * A modal that displays a Markdown formatted message, with affirmative or declinatory dismiss buttons.
     */
    export default {
        name: 'confirm',

        props: {
            /**
             * The message displayed in the modal.
             */
            msg: {
                type: String,
                required: true
            },
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String,
            /**
             * Semantic color class applied to button.
             */
            tone: {
                type: String,
                default: 'accent'
            },
            /**
             * An alternative label for the action button.
             * This should almost always be specified. Users will not read the message in your dialog box.
             */
            verb: String,
            /**
             * An alternative label for the dismiss button.
             */
            verbCancel: String,
            /**
             * A function called after clicking the Accept button.
             */
            action: Function,
            /**
             * A function called after clicking the Cancel button.
             */
            cancel: Function,
            /**
             * If `true`, display a "Do not show this message again" checkbox and pass its value
             * as an option to the `action` function.
             */
            dismissable: Boolean
        },

        data() {
            return {
                dismiss: false
            };
        },

        methods: {
            open() {
                this.dismiss = false;
                this.$refs.modal.open();
            },

            onCancel() {
                this.$refs.modal.close();
                if (this.cancel) {
                    this.$nextTick(this.cancel);
                }
            },

            onAccept() {
                this.$refs.modal.close();
                if (this.action) {
                    this.$nextTick(() => {
                        this.action({
                            dismiss: this.dismiss
                        });
                    });
                }
            }
        }
    }
</script>
